import {
  DO_SIGNUP_START,
  DO_SIGNUP_SUCCESS,
  DO_SIGNUP_FAILED,
  DO_VERIFY_EMAIL_SUCCEED,
  DO_LOGIN_START,
  DO_LOGIN_SUCCESS,
  DO_LOGIN_FAILED,
  LOGOUT_SUCCESS,
  DO_LOGGED_IN_WITH_DOMAIN,
  DO_SET_AUTH_INFO,
  DO_REMOVE_AUTH_INFO,
  UPDATE_USER_PERMISSION,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  UPDATE_PASSWORD_START,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILED,
  UPLOAD_PROFILE_START,
  UPLOAD_PROFILE_SUCCESS,
  UPLOAD_PROFILE_FAILED
} from '../actionTypes/auth'

// The initial state of the App
export const initialState = {
  isLoading: false,
  isLoggedIn: false,
  token: '',
  user: {},
  subdomain: ''
}

const auth = (state = initialState, action) => {
  switch (action.type) {
    case DO_SIGNUP_START:
      return {
        ...state,
        isLoading: true
      };
    case DO_SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DO_SIGNUP_FAILED:
      return {
        ...state,
        isLoading: false
      }
    case DO_VERIFY_EMAIL_SUCCEED:
      return {
        ...state,
        subdomain: action.data.subdomain
      }
    case DO_LOGIN_START:
      return {
        ...state,
        isLoading: true
      };
    case DO_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        token: action.data.accessToken,
        user: action.data
      }
    case DO_LOGIN_FAILED:
      return {
        ...state,
        isLoading: false
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        token: '',
        user: {},
      }
    case DO_LOGGED_IN_WITH_DOMAIN:
      return {
        ...state,
        isLoggedIn: true,
      }
    case DO_SET_AUTH_INFO:
      return {
        ...state,
        isLoggedIn: true,
        token: action.data.token,
        user: action.data.user
      }
    case DO_REMOVE_AUTH_INFO:
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        user: null,
      }
    case UPDATE_USER_PERMISSION:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data
        }
      }
    case UPDATE_USER_START:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: {
          ...state.user,
          ...action.data
        }
      }
    case UPDATE_USER_FAILED:
      return {
        ...state,
        isLoading: false
      }
      case UPDATE_USER_START:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_USER_SUCCESS:
        return {
          ...state,
          isLoading: false,
          user: {
            ...state.user,
            ...action.data
          }
        }
      case UPDATE_USER_FAILED:
        return {
          ...state,
          isLoading: false
        }

        case UPLOAD_PROFILE_START:
          return {
            ...state,
            isLoading: true
          }
    
        case UPLOAD_PROFILE_SUCCESS:
          return {
            ...state,
            isLoading: false,
            user: {
              ...state.user,
              ...action.data,
            }
          }
    
        case UPLOAD_PROFILE_FAILED:
          return {
            ...state,
            isLoading: false

          }
    default:
      return state
  }
}

export default auth
